import { SpaceGoBalanceProps } from './types';
import { StyledSpaceGoBalance } from './style';
import { formattingNumber } from '../../Helper/utils/utils';

const SpaceGoBalance = ({
    balance,
    balanceQuantityFormat
}: SpaceGoBalanceProps) => {
    return (
        <StyledSpaceGoBalance>
            <img className="balanceImg" alt="balance" src={balance.image} />
            <span>
                {balanceQuantityFormat
                    ? formattingNumber(balance.amount, balanceQuantityFormat)
                    : balance.amount}
            </span>
        </StyledSpaceGoBalance>
    );
};

export default SpaceGoBalance;
